export const colorsMap: Record<string, string> = {
  'sky-blue': '#87CEEB',
  'crimson-red': '#DC143C',
  'lime-flash': '#32CD32',
  'pink-blaze': '#FF69B4',
};
